var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.appClass, attrs: { id: "app" } },
    [
      _c(
        "div",
        { staticClass: "app-left" },
        [
          _vm.showXepAside
            ? _c("xep-platform-aside", {
                ref: "xepAside",
                on: { "change-nav": _vm.changeNav },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-right" },
        [
          _c(
            "keep-alive",
            { attrs: { include: _vm.includeRoutes } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _vm.isLittleDoctor
        ? _c(
            "div",
            {
              staticClass: "back-door-doctor",
              attrs: { title: "点击小箭头可折叠或收起小博士按钮" },
            },
            [
              _c("span", {
                class: _vm.foldBackDoor
                  ? "el-icon-arrow-left"
                  : "el-icon-arrow-right",
                staticStyle: { "margin-right": "2px" },
                on: {
                  click: function ($event) {
                    _vm.foldBackDoor = !_vm.foldBackDoor
                  },
                },
              }),
              _c("el-switch", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.foldBackDoor === false,
                    expression: "foldBackDoor === false",
                  },
                ],
                attrs: {
                  "active-text": "小博士开",
                  "inactive-text": "小博士关",
                },
                on: { change: _vm.setLittleDoctor },
                model: {
                  value: _vm.backDoor,
                  callback: function ($$v) {
                    _vm.backDoor = $$v
                  },
                  expression: "backDoor",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "edge-bar",
        },
        [
          _c("li", { staticClass: "qrcode-wrap" }, [
            _c("div", { staticClass: "qrcode" }, [
              _vm.$store.getters.isTest
                ? _c("img", {
                    attrs: { src: require("images/qrcode_testing.png") },
                  })
                : _c("img", { attrs: { src: require("images/qrcode.png") } }),
              _c("div", [_vm._v("扫码关注公众号")]),
              _c("p", [_vm._v("手机阅卷并查看报告")]),
            ]),
            _c("div", { staticClass: "icon icon-qrcode" }),
          ]),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShow,
                  expression: "isShow",
                },
              ],
              on: {
                click: function ($event) {
                  return _vm.toTop()
                },
              },
            },
            [
              _c("span", [_vm._v("回到顶部")]),
              _c("div", { staticClass: "icon icon-top" }),
            ]
          ),
        ]
      ),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.notSubjectVisible,
            width: "360px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.notSubjectVisible = $event
            },
          },
        },
        [
          _c("p", { staticStyle: { "line-height": "1.5" } }, [
            _vm._v(
              "您的帐号当前暂未绑定学科，可能导致您无法查看考试报告。详情请咨询管理员～"
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.notSubjectVisible = false
                    },
                  },
                },
                [_vm._v(" 我知道了 ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("yue-notice", {
        attrs: { item: _vm.noticeDialogData },
        on: { close: _vm.closeNoticeDialog },
      }),
      _c("yue-no-permission", { attrs: { item: _vm.permissionItem } }),
      _c("yue-client-update", {
        attrs: { item: _vm.clientUpdateItem },
        on: { download: _vm.downloadExe, close: _vm.closeClientUpdateDialog },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }